import { z } from 'zod';

export const fsDirectoryFilterSettingsSchema = z.object({
  idFSDirectoryType: z.number(),
  idFSDirectoryArray: z.array(z.number()),
  create_time_filter: z.number(),
  show_empty_directories: z.boolean(),
  show_sorted_directories: z.boolean(),
});

export const IFsDirectorySchema = z.object({
  idFSDirectory: z.number(),
  idFSDirectoryType: z.number(),
  idFSDirectoryProtocol: z.number(),
  idFSDirectoryAuthentication: z.number(),
  OriginPath: z.string(),
  Name: z.string(),
  Server: z.string(),
  User: z.string(),
  Password: z.string().nullable(),
});

export const IFSScanResultSchema = z.object({
  fileName: z.string(),
  idFSDirectory: z.number(),
  path: z.string(),
  created_at: z.string(),
  isSorted: z.boolean(),
});

export const FSSelectObjectSchema = z.object({
  section: z
    .enum(['certificate', 'invoice', 'dms', 'legalRequirements'])
    .or(z.string()),
  idDocumentDirectory: z.number(),
  idLegalRequirement: z.number(),
  FSScanResult: IFSScanResultSchema,
});

export type IFSScanResult = z.infer<typeof IFSScanResultSchema>;
export type IFsDirectoryFilterSettings = z.infer<
  typeof fsDirectoryFilterSettingsSchema
>;
export type IFSDirectory = z.infer<typeof IFsDirectorySchema>;

export type IFSSelectObject = z.infer<typeof FSSelectObjectSchema>;

/// Die Zeitraeume, die `checkCreateTimeFilter` im Backend kennt. Jeder andere
/// Wert faellt dort in den else-Zweig und filtert nichts -- das ist die 0.
export const FS_TIME_FILTER_OPTIONS = [
  { value: 1, label: 'Heute' },
  { value: 2, label: 'Letzte 3 Tage' },
  { value: 3, label: 'Diese Woche' },
  { value: 4, label: 'Diesen Monat' },
  { value: 0, label: 'Alle' },
] as const;

export const DEFAULT_TIME_FILTER = 2;

/// Bringt einen gespeicherten Filterwert auf einen der bekannten Zeitraeume.
/// `useLocalStorage` merged keine Defaults, ein Alt-Objekt kennt das Feld also
/// womoeglich gar nicht -- und ohne das Feld antwortet /fsdirectory/scan mit
/// 400. Zwei Fallen dabei: `Number(null)` ist 0 und wuerde stillschweigend zu
/// "Alle", und ein `value || DEFAULT` wuerde eine bewusst gewaehlte 0 wieder
/// wegwerfen.
export const resolveTimeFilter = (value: unknown): number => {
  const isUsable =
    typeof value === 'number' ||
    (typeof value === 'string' && value.trim() !== '');

  if (!isUsable) {
    return DEFAULT_TIME_FILTER;
  }

  const parsed = Number(value);

  return FS_TIME_FILTER_OPTIONS.some(option => option.value === parsed)
    ? parsed
    : DEFAULT_TIME_FILTER;
};

export const getInitialFilterObject = (): IFsDirectoryFilterSettings => {
  return {
    idFSDirectoryType: 0,
    idFSDirectoryArray: [],
    create_time_filter: DEFAULT_TIME_FILTER,
    show_empty_directories: true,
    show_sorted_directories: true,
  };
};

export const getEmptyFSSelectObject = (fsScanObject: IFSScanResult) => {
  return {
    section: 'legalRequirements',
    idDocumentDirectory: -1,
    idLegalRequirement: -1,
    FSScanResult: fsScanObject,
  } as IFSSelectObject;
};
